import { FC } from "react";
import { Col, Row, Typography } from "antd";

const { Text } = Typography;

const StatusVehicleBody: FC<{ data: any }> = ({ data }) => {
  const groupedParts = {
    orjinal: data.filter(
      (item: any) =>
        item.status.orginal &&
        !item.status.localPainted &&
        !item.status.painted &&
        !item.status.changed
    ),
    localPainted: data.filter((item: any) => item.status.localPainted),
    painted: data.filter((item: any) => item.status.painted),
    changed: data.filter((item: any) => item.status.changed),
    undefined: data.filter(
      (item: any) =>
        !item.status.orginal &&
        !item.status.localPainted &&
        !item.status.painted &&
        !item.status.changed
    ),
  };

  const sections = [
    {
      title: "Orjinal",
      color: "#3BB143", // yeşil
      items: groupedParts.orjinal,
    },
    {
      title: "Lokal boyalı",
      color: "#D9A441", // sarımsı
      items: groupedParts.localPainted,
    },
    {
      title: "Boyalı",
      color: "#FFD700", // sarı
      items: groupedParts.painted,
    },
    {
      title: "Değişmiş",
      color: "#E2555E", // kırmızı
      items: groupedParts.changed,
    },
    {
      title: "Belirtilmemiş",
      color: "#B0B0B0", // gri
      items: groupedParts.undefined,
    },
  ];

  return (
    <Row gutter={[0, 20]}>
      <Col xs={24}>
        <Text className="!text-xl !font-bold">Gövde Özellikleri</Text>
      </Col>

      {sections.map((section) => (
        <Col xs={24} key={section.title}>
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <span
              style={{
                width: 10,
                height: 10,
                backgroundColor: section.color,
                borderRadius: "50%",
                display: "inline-block",
              }}
            />
            <Text strong style={{ fontSize: 16 }}>
              {section.title}
            </Text>
          </div>

          <Text style={{ marginLeft: 18, display: "block", marginTop: 4 }}>
            {section.items.length > 0
              ? section.items.map((item: any) => item.parca).join(" · ")
              : "-"}
          </Text>
        </Col>
      ))}
    </Row>
  );
};

export default StatusVehicleBody;
